// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bClubSendMessagesFields {
  background-color: #ebf7fb;
  border-radius: 5px;
  margin-top: 8px;
  min-height: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.confirmationRequestForm__deadline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.confirmationRequestForm__deadline > div:first-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.confirmationRequestForm__deadline strong {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 750;
}

.confirmationRequestForm__deadline span {
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
}

.confirmationRequestForm__dateTimePicker {
  width: 260px;
  flex: 0 0 260px;
}

.confirmationRequestForm__dateTimePicker .sit-dp__pop {
  z-index: 1400;
}

.confirmationRequestForm__summary {
  margin-top: 10px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.confirmationRequestForm__error {
  margin: 10px 0 0;
  padding: 9px 11px;
  border: 1px solid var(--red-200, #fecdd3);
  border-radius: 8px;
  background: var(--red-50, #fff1f2);
  color: var(--red-700, #b42335);
  font-size: 12px;
}

@media (max-width: 720px) {
  .confirmationRequestForm__deadline {
    align-items: stretch;
    flex-direction: column;
  }

  .confirmationRequestForm__dateTimePicker {
    width: 100%;
    flex-basis: auto;
  }
}

.eConsentDeadlinePickerWrapper {
  width: 100%;

  .react-datepicker__input-container {
    width: 100%;
  }

  input.form-control {
    border-radius: 10px;
    padding: 10px 12px;
    border: 1px solid #d6dee6;
    box-shadow: 0 1px 0 rgba(16, 24, 40, 0.04);
    transition: border-color 120ms ease, box-shadow 120ms ease;

    &:focus {
      border-color: #2b8fdc;
      box-shadow: 0 0 0 3px rgba(43, 143, 220, 0.18);
      outline: none;
    }
  }
}

.eConsentDeadlinePickerPopper {
  z-index: 9999;
}

.eConsentDeadlinePickerCalendar {
  border: 0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.18);
  font-family: inherit;

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 130px;
  }

  .react-datepicker__header {
    background: #f4f9ff;
    border-bottom: 1px solid #e6eef6;
    padding-top: 10px;
  }

  .react-datepicker__current-month {
    font-weight: 700;
    color: #0f2f4a;
    margin-bottom: 6px;
  }

  .react-datepicker__month-dropdown-container,
  .react-datepicker__year-dropdown-container {
    select {
      border-radius: 10px;
      border: 1px solid #d6dee6;
      padding: 6px 10px;
      background: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .react-datepicker__day-names {
    margin-top: 6px;
  }

  .react-datepicker__day-name {
    color: #5b6b7b;
    font-weight: 600;
    width: 2.1rem;
    line-height: 2.1rem;
    margin: 0.1rem;
  }

  .react-datepicker__day {
    width: 2.1rem;
    line-height: 2.1rem;
    margin: 0.1rem;
    border-radius: 10px;
    color: #0f2f4a;
    transition: background-color 120ms ease, color 120ms ease, transform 80ms ease;

    &:hover {
      background: rgba(43, 143, 220, 0.1);
      color: #0f2f4a;
    }
  }

  .react-datepicker__day--today {
    font-weight: 800;
    color: #1a6fb6;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 6px;
      width: 4px;
      height: 4px;
      border-radius: 999px;
      transform: translateX(-50%);
      background: #1a6fb6;
      opacity: 0.9;
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: #2b8fdc;
    color: #fff;

    &:hover {
      background: #1f7fc8;
      color: #fff;
    }
  }

  .react-datepicker__day--disabled {
    color: #aab7c4;
    background: transparent;
    cursor: not-allowed;
  }

  .react-datepicker__time-container {
    border-left: 1px solid #e6eef6;
    width: 130px;
  }

  .react-datepicker__time {
    background: #fff;
  }

  .react-datepicker__time-box {
    width: 130px;
  }

  .react-datepicker__time-list {
    padding: 6px;
  }

  .react-datepicker__time-list-item {
    border-radius: 10px;
    margin: 2px 0;
    padding: 8px 10px;
    transition: background-color 120ms ease;

    &:hover {
      background: rgba(43, 143, 220, 0.1);
    }
  }

  .react-datepicker__time-list-item--selected {
    background: #2b8fdc !important;
    color: #fff !important;
    font-weight: 700;
  }

  .react-datepicker__time-list::-webkit-scrollbar {
    width: 10px;
  }

  .react-datepicker__time-list::-webkit-scrollbar-thumb {
    background: #d2dde8;
    border-radius: 10px;
    border: 2px solid #fff;
  }

  .react-datepicker__time-list::-webkit-scrollbar-thumb:hover {
    background: #b8c7d6;
  }
}

.eConsentDeadlinePickerWrapper .react-datepicker__close-icon {
  top: 50%;
  transform: translateY(-50%);
}

.eConsentDeadlinePickerWrapper .react-datepicker__close-icon::after {
  line-height: 1;
}

.eConsentDeadlinePickerWrapper .react-datepicker-wrapper,
.eConsentDeadlinePickerWrapper .react-datepicker__input-container {
  width: auto !important;
  display: inline-block !important;
}

.eConsentDeadlinePickerWrapper .react-datepicker__input-container input.form-control {
  width: 240px;
  max-width: 100%;
  padding-right: 44px;
}

.eConsentDeadlinePickerWrapper .react-datepicker__input-container > button.react-datepicker__close-icon {
  right: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin-top: -2px !important;

  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.eConsentDeadlinePickerWrapper .react-datepicker__input-container > button.react-datepicker__close-icon::after {
  position: static !important;
  transform: none !important;
  margin: 0 !important;
  line-height: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmationRequestForm/ConfirmationRequestForm.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;;EAEX;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;IAC1C,0DAA0D;;IAE1D;MACE,qBAAqB;MACrB,8CAA8C;MAC9C,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,oBAAoB;;EAEpB;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE;MACE,mBAAmB;MACnB,yBAAyB;MACzB,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,eAAe;IACjB;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,8EAA8E;;IAE9E;MACE,mCAAmC;MACnC,cAAc;IAChB;EACF;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;;IAElB;MACE,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,UAAU;MACV,WAAW;MACX,oBAAoB;MACpB,2BAA2B;MAC3B,mBAAmB;MACnB,YAAY;IACd;EACF;;EAEA;;IAEE,mBAAmB;IACnB,WAAW;;IAEX;MACE,mBAAmB;MACnB,WAAW;IACb;EACF;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;;IAEvC;MACE,mCAAmC;IACrC;EACF;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;;EAE3B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;;EAErB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;AAC3B","sourcesContent":[".bClubSendMessagesFields {\n  background-color: #ebf7fb;\n  border-radius: 5px;\n  margin-top: 8px;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.confirmationRequestForm__deadline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.confirmationRequestForm__deadline > div:first-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.confirmationRequestForm__deadline strong {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.confirmationRequestForm__deadline span {\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n}\n\n.confirmationRequestForm__dateTimePicker {\n  width: 260px;\n  flex: 0 0 260px;\n}\n\n.confirmationRequestForm__dateTimePicker .sit-dp__pop {\n  z-index: 1400;\n}\n\n.confirmationRequestForm__summary {\n  margin-top: 10px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.confirmationRequestForm__error {\n  margin: 10px 0 0;\n  padding: 9px 11px;\n  border: 1px solid var(--red-200, #fecdd3);\n  border-radius: 8px;\n  background: var(--red-50, #fff1f2);\n  color: var(--red-700, #b42335);\n  font-size: 12px;\n}\n\n@media (max-width: 720px) {\n  .confirmationRequestForm__deadline {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .confirmationRequestForm__dateTimePicker {\n    width: 100%;\n    flex-basis: auto;\n  }\n}\n\n.eConsentDeadlinePickerWrapper {\n  width: 100%;\n\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n\n  input.form-control {\n    border-radius: 10px;\n    padding: 10px 12px;\n    border: 1px solid #d6dee6;\n    box-shadow: 0 1px 0 rgba(16, 24, 40, 0.04);\n    transition: border-color 120ms ease, box-shadow 120ms ease;\n\n    &:focus {\n      border-color: #2b8fdc;\n      box-shadow: 0 0 0 3px rgba(43, 143, 220, 0.18);\n      outline: none;\n    }\n  }\n}\n\n.eConsentDeadlinePickerPopper {\n  z-index: 9999;\n}\n\n.eConsentDeadlinePickerCalendar {\n  border: 0;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.18);\n  font-family: inherit;\n\n  .react-datepicker__triangle {\n    display: none;\n  }\n\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 130px;\n  }\n\n  .react-datepicker__header {\n    background: #f4f9ff;\n    border-bottom: 1px solid #e6eef6;\n    padding-top: 10px;\n  }\n\n  .react-datepicker__current-month {\n    font-weight: 700;\n    color: #0f2f4a;\n    margin-bottom: 6px;\n  }\n\n  .react-datepicker__month-dropdown-container,\n  .react-datepicker__year-dropdown-container {\n    select {\n      border-radius: 10px;\n      border: 1px solid #d6dee6;\n      padding: 6px 10px;\n      background: #fff;\n      font-size: 14px;\n      cursor: pointer;\n    }\n  }\n\n  .react-datepicker__day-names {\n    margin-top: 6px;\n  }\n\n  .react-datepicker__day-name {\n    color: #5b6b7b;\n    font-weight: 600;\n    width: 2.1rem;\n    line-height: 2.1rem;\n    margin: 0.1rem;\n  }\n\n  .react-datepicker__day {\n    width: 2.1rem;\n    line-height: 2.1rem;\n    margin: 0.1rem;\n    border-radius: 10px;\n    color: #0f2f4a;\n    transition: background-color 120ms ease, color 120ms ease, transform 80ms ease;\n\n    &:hover {\n      background: rgba(43, 143, 220, 0.1);\n      color: #0f2f4a;\n    }\n  }\n\n  .react-datepicker__day--today {\n    font-weight: 800;\n    color: #1a6fb6;\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 50%;\n      bottom: 6px;\n      width: 4px;\n      height: 4px;\n      border-radius: 999px;\n      transform: translateX(-50%);\n      background: #1a6fb6;\n      opacity: 0.9;\n    }\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--keyboard-selected {\n    background: #2b8fdc;\n    color: #fff;\n\n    &:hover {\n      background: #1f7fc8;\n      color: #fff;\n    }\n  }\n\n  .react-datepicker__day--disabled {\n    color: #aab7c4;\n    background: transparent;\n    cursor: not-allowed;\n  }\n\n  .react-datepicker__time-container {\n    border-left: 1px solid #e6eef6;\n    width: 130px;\n  }\n\n  .react-datepicker__time {\n    background: #fff;\n  }\n\n  .react-datepicker__time-box {\n    width: 130px;\n  }\n\n  .react-datepicker__time-list {\n    padding: 6px;\n  }\n\n  .react-datepicker__time-list-item {\n    border-radius: 10px;\n    margin: 2px 0;\n    padding: 8px 10px;\n    transition: background-color 120ms ease;\n\n    &:hover {\n      background: rgba(43, 143, 220, 0.1);\n    }\n  }\n\n  .react-datepicker__time-list-item--selected {\n    background: #2b8fdc !important;\n    color: #fff !important;\n    font-weight: 700;\n  }\n\n  .react-datepicker__time-list::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .react-datepicker__time-list::-webkit-scrollbar-thumb {\n    background: #d2dde8;\n    border-radius: 10px;\n    border: 2px solid #fff;\n  }\n\n  .react-datepicker__time-list::-webkit-scrollbar-thumb:hover {\n    background: #b8c7d6;\n  }\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker__close-icon {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker__close-icon::after {\n  line-height: 1;\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker-wrapper,\n.eConsentDeadlinePickerWrapper .react-datepicker__input-container {\n  width: auto !important;\n  display: inline-block !important;\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker__input-container input.form-control {\n  width: 240px;\n  max-width: 100%;\n  padding-right: 44px;\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker__input-container > button.react-datepicker__close-icon {\n  right: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  margin-top: -2px !important;\n\n  width: 28px !important;\n  height: 28px !important;\n  padding: 0 !important;\n\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.eConsentDeadlinePickerWrapper .react-datepicker__input-container > button.react-datepicker__close-icon::after {\n  position: static !important;\n  transform: none !important;\n  margin: 0 !important;\n  line-height: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
